import React, { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import useAppContext from "../AppContext";
import routes from "../../routes";
import { useLogger } from "../../utils/useLogger";

export default function RedirectFirstQuestion() {
  const { assessment, newQuiz } = useAppContext();
  const { trigger: log } = useLogger();
  const location = useLocation();
  const path = assessment.questions[0].urlPath;

  useEffect(() => {
    if (newQuiz.isSequence) {
      log({
        redirectFromPath: location?.pathname,
        redirectFromSearch: location?.search,
        redirectToPath: routes?.question(path),
        redirectToSearch: location?.search
      });
    }
  }, []);

  return (
    <Redirect
      to={{
        pathname: routes.question(path),
        search: location.search
      }}
    />
  );
}
